export default "__VITE_ASSET__DCIGi0V6__"